import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as updateConfigurationActions from '../../../actions/updateConfigurationActions';
import {ModalButton} from '../../../components/ModalButton';
import * as _ from 'lodash';
import {GranitePicker} from '../components/GranitePicker'
import { isConfigRequested } from "../../../services/configurationWarningChecks"
import { TranslationContext } from "../../../context/TranslationContext";
import {imgs} from '../../../services/images.service';
import {displayGranitConfigImage} from '../../../services/image.fct.service';
import { resetLazyImageQueue } from '../../../components/LazyImage';
import {gtmPro} from '../../../services/gtmPro';

/**
 * ModalButton permettant de choisir le granite pour tout le placage
 */
class VeneerGranitePickerComponent extends Component {
  static contextType = TranslationContext;
  static propTypes = {
    veneer: PropTypes.object,
  };

  state = {
    showImage: true,
  }

  modal;

  onSelectGranite = (graniteRef) => {
    const selectedGranite = (this.props.granites || []).find((granite) => granite.reference === graniteRef);
    gtmPro().clickGranite(selectedGranite || { reference: graniteRef }, 'veneer');
    this.modal.close();
    this.setState({showImage: false}, () => {
      if(this.props.monument.kind === 'PLT'){
        this.props.actions.updateGraniteMonument(graniteRef);
      }
      this.props.actions.updateGraniteVeneer(graniteRef);
      setTimeout(() => {
        this.setState({showImage: true});
      }, 1000);
    });
  };

   onModalClose = () =>{
      resetLazyImageQueue();
      this.setState({showImage: false}, () => {
  
        setTimeout(() => {
          this.setState({showImage: true})
        }, 1000);
      })
    }

  makePreviewUrl = (graniteRef)=> {
    const {monument, configuration} = this.props;
    // return imgs.configuration.monument.iso.thumbnail({
    //   monument,
    //   veneer: Object.assign({}, veneer, {granite: graniteRef})
    // }, {
    //   excludeDefaultPattern: true
    // })
    return displayGranitConfigImage(configuration,
      monument.graniteMain,
      false,
      monument.graniteSecondary,
      "thumbnail",
      false,
      0,
      0,
      0,
      graniteRef,
      0)
  };

  handleGranitsClick = () => {
    let gtmName = "extranet.config3d.config3d_granit_button_veneer";
    gtmPro().ctaOfConfiguration(
      {
        name: gtmName,
        category: "configurateur",
        subcategory: "Granit",
        type: "cta",
        from: "left"
      },
      {template:"configurateur", subtemplate:"granits"},
      {},
      "partner",
      "product",
      "user",
      "page"
    );
  };

  render() {
    const t = this.context;
    const veneer = this.props.veneer;
    const hasVeneer = _.some(
      ['left', 'right', 'back', 'front'],
      (side) => {
        const {left, right, back, front, length, thickness} = _.get(veneer, `dimensions.${side}`) || {};
        return !!length && !!thickness && (!!left || !!right || !!back || !!front);
      });
      const disabled = !hasVeneer || isConfigRequested();

    const buttonContent = t("config3d_granit_button_veneer") || "Placage";
    return (
      <div className={"btn-wrapper"}>
        <ModalButton
          ref={(_modal) => this.modal = _modal}
          buttonContent={buttonContent}
          buttonIcon="veneer-icon"
          className="VeneerGranitePickerPopupModal buttonModal background-page"
          overlayClassName="VeneerGranitePickerPopupModalOverlay"
          disabled={disabled}
          buttonClassName={`btn-config-secondary text-dark config-button-background ${!disabled && 'config-button-hover'}`}
          toggleSteps={this.props.toggleSteps}
          launchIntro={this.props.launchIntro}
          modalName={this.props.modalName}
          onClick={() => this.handleGranitsClick()}
          onModalClose={this.onModalClose}
          >
          {this.state.showImage &&
          <GranitePicker
            currentGraniteRef={veneer && veneer.granite}
            onPickGraniteRef={this.onSelectGranite}
            suggestionImageURL={this.makePreviewUrl}
            title={t("config3d_granit_modal_veneer_title") || "Choisissez un granit à appliquer sur le placage"}
            type="veneer"
          />
          }
        </ModalButton>
      </div>
    );
  }
}

export const VeneerGranitePicker = connect((state) => ({
    veneer: state.configurator.current.configuration.veneer,
    monument: state.configurator.current.configuration.monument,
  configuration: state.configurator.current.configuration,
  granites: state.configurator.current.options.granites,
  }),
  (dispatch) => ({
    actions: bindActionCreators(updateConfigurationActions, dispatch)
  })
)(VeneerGranitePickerComponent);
